export default __webpack_public_path__ + "static/media/IMG7170.f495c795.jpg";